export default function (con) {

  let convenio = {}

  convenio.convenioId = con ? con.convenioId : null
  convenio.tipoConvenio = con ? con.tipoConvenio : { tipoConvenioId: null, descricao: "" }

  convenio.anoParceria = con ? con.anoParceria : null
  convenio.numeroParceria = con ? con.numeroParceria : null
  convenio.vigenciaParceria = con ? con.vigenciaParceria : null
  convenio.arquivo = con ? con.arquivo : ""
  convenio.numeroProcesso = con ? con.numeroProcesso : null
  convenio.anoProcesso = con ? con.anoProcesso : null
  convenio.convenente = con ? con.convenente : ""
  convenio.responsavel = con ? con.responsavel : ""
  convenio.objeto = con ? con.objeto : ""
  convenio.dataAssinatura = con ? con.dataAssinatura : ""
  convenio.vigencia = con ? con.vigencia : null
  
  return convenio

}